var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mb-2" },
    [
      _c(
        "b-col",
        [
          _c("b-row", [
            _c("div", { attrs: { id: "system-header" } }, [
              _c("h1", {}, [_vm._v(_vm._s(_vm.$t("title")))])
            ])
          ]),
          _vm._v(" "),
          _vm.compact
            ? _c(
                "b-row",
                [
                  _vm.system.SystemPartNumber !== ""
                    ? _c("b-col", { attrs: { md: "4" } }, [
                        _c("p", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("terminal.hardware")) +
                              ": " +
                              _vm._s(_vm.system.SystemPartNumber) +
                              " (" +
                              _vm._s(
                                _vm.$t(
                                  "systemtypes." + _vm.system.SystemPartNumber
                                )
                              ) +
                              ")\n        "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "4" } }, [
                    _c("p", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("terminal.serialnumber")) +
                          ": " +
                          _vm._s(_vm.system.SerialNumber) +
                          "\n        "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.system.Location !== ""
                    ? _c("b-col", { attrs: { md: "4" } }, [
                        _c("p", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("terminal.location")) +
                              ": " +
                              _vm._s(_vm.system.Location) +
                              "\n        "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.verbose
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "5" } },
                    [
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("terminal.serialnumber")) +
                              ": " +
                              _vm._s(_vm.system.SerialNumber)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.files.credit !== undefined && _vm.type === "credit"
                        ? _c(
                            "b-button",
                            {
                              staticClass: "file-button",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function($event) {
                                  return _vm.downloadCreditFile()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("buttons.download.credit")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.files.license !== undefined && _vm.type === "config"
                        ? _c(
                            "b-button",
                            {
                              staticClass: "file-button",
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function($event) {
                                  return _vm.downloadConfigFile()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("buttons.download.license")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "7" } }, [
                    _c("ul", [
                      _vm.system.SystemPartNumber !== ""
                        ? _c("li", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("terminal.hardware")) +
                                ": " +
                                _vm._s(_vm.system.SystemPartNumber) +
                                " (" +
                                _vm._s(
                                  _vm.$t(
                                    "systemtypes." + _vm.system.SystemPartNumber
                                  )
                                ) +
                                ")\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.system.Location !== ""
                        ? _c("li", [
                            _vm._v(
                              _vm._s(_vm.$t("terminal.location")) +
                                ": " +
                                _vm._s(_vm.system.Location)
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.compact == false && _vm.type === "credit"
                        ? _c("li", [
                            _vm._v(
                              _vm._s(_vm.$t("terminal.credit")) +
                                "\n              "
                            ),
                            _c(
                              "ul",
                              _vm._l(_vm.history.credit, function(file) {
                                return _c("li", { key: file.FileID }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.parseDate(file.Created)) +
                                      ": " +
                                      _vm._s(file.User.CompanyName) +
                                      "  " +
                                      _vm._s(
                                        file.CreditFile.Unit === "CREDIT"
                                          ? _vm.$t("history.credit", {
                                              amount: file.CreditFile.Amount
                                            })
                                          : _vm.$t("history.days", {
                                              amount: file.CreditFile.Amount
                                            })
                                      ) +
                                      "\n              "
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.compact == false && _vm.type === "config"
                        ? _c("li", [
                            _vm._v(
                              _vm._s(_vm.$t("terminal.config")) +
                                "\n              "
                            ),
                            _c(
                              "ul",
                              _vm._l(_vm.history.license, function(file) {
                                return _c("li", { key: file.FileID }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.parseDate(file.Created)) +
                                      ": " +
                                      _vm._s(file.User.CompanyName) +
                                      "\n              "
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b583e54e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b583e54e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/subcomponent/SystemDetails.vue
// module id = 778
// module chunks = 0